import { IMessageListFilter, IUserInfo } from "@home-health-notify/domain";
// Call button hidden for now — may be implemented later
// import CallIcon from "@mui/icons-material/Call";
import InfoIcon from "@mui/icons-material/Info";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, Tooltip, useMediaQuery } from "@mui/material";
import { useTranslation } from "hhn-commons";
import React, { useContext } from "react";
import { RightDrawerContext } from "../../../context/RightDrawerContext";
import { RESPONSIVE_DRAWER } from "../../../common/Common.style";
import {
  ActionIcons,
  HeaderDescriptionWrapper,
  PrivateHeaderWrapper,
} from "../../MessageHeader.style";
import { CommonChatHeaderDescription } from "../CommonChatHeaderDescription";
import { PrivateMessageSearch } from "./PrivateMessageSearch";
import { useSnackbar } from "notistack";
import { LoadingOverlay } from "../commonHeader/GroupHeader.style";

interface PrivateHeaderProps {
  userInfo: IUserInfo;
  showSearch: boolean;
  setShowSearch: (toShow: boolean) => void;
  onFilter: (filters: IMessageListFilter) => void;
  isChatLoading: boolean;
}

export const PrivateHeader = ({
  userInfo,
  showSearch,
  setShowSearch,
  onFilter,
  isChatLoading,
}: PrivateHeaderProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });
  const tNsInfo = (key: string) => t(key, { ns: "groupChatInfo" });

  const {
    openChatInfoDrawer,
    closeDrawer,
    open: chatInfoDrawerOpen,
  } = useContext(RightDrawerContext);

  const isNarrow = useMediaQuery(
    `(max-width: ${RESPONSIVE_DRAWER.WIDE_BP - 1}px)`,
  );
  const isCompactHeader = chatInfoDrawerOpen || isNarrow;

  const toggleChatInfoDrawer = () => {
    !chatInfoDrawerOpen ? openChatInfoDrawer() : closeDrawer();
  };

  const onChatInfoClick = () => {
    if (isChatLoading) return;
    toggleChatInfoDrawer();
  };

  const onMessageSearch = () => {
    if (isChatLoading) return;
    setShowSearch(true);
  };

  const showLoadingSnackbar = () => {
    enqueueSnackbar(tNsInfo("chatInfoLoading"), {
      autoHideDuration: 3000,
    });
  };

  return (
    <PrivateHeaderWrapper data-testid="private-header-component">
      <LoadingOverlay
        isLoading={isChatLoading}
        onClick={showLoadingSnackbar}
        data-testid="loading-overlay"
      />
      {!(showSearch && isCompactHeader) && (
        <HeaderDescriptionWrapper onClick={onChatInfoClick}>
          <CommonChatHeaderDescription chatInfo={userInfo} />
        </HeaderDescriptionWrapper>
      )}
      {showSearch ? (
        <PrivateMessageSearch
          onClearSearch={() => setShowSearch(false)}
          onFilter={onFilter}
          fullWidth={showSearch && isCompactHeader}
        />
      ) : (
        <ActionIcons data-testid="actionItems">
          <IconButton onClick={onMessageSearch} disableTouchRipple>
            <Tooltip title={tNs("searchChat")}>
              <SearchIcon />
            </Tooltip>
          </IconButton>
          {/* Call button hidden for now — may be implemented later
          <IconButton disabled disableTouchRipple>
            <Tooltip title={tNs("voiceCall")}>
              <CallIcon />
            </Tooltip>
          </IconButton> */}
          <IconButton onClick={onChatInfoClick} disableTouchRipple>
            <Tooltip title={tNs("chatInfo")}>
              <InfoIcon data-testid="chatInfo-btn" />
            </Tooltip>
          </IconButton>
        </ActionIcons>
      )}
    </PrivateHeaderWrapper>
  );
};
